export default __webpack_public_path__ + "static/media/orderform-active.f5b0baec.svg";